import { Component, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { QueryObjectsModel, QueryOutputMode } from '@barthauer/abc/core/data';
import { HighlightSyntax, _AbcTreeNode } from '@barthauer/abc/ui-components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbcQueriesEditorService } from '../../../abc-queries-editor.service';
import { ResultsService } from '../../../services/result.service';
import { Property } from '../../../viewModels/abc-queries-editor.viewModel';

@Component({
  selector: 'abc-opath-queries-editor-results-query-json',
  templateUrl: './results-query-json.component.html',
  styleUrls: ['./results-query-json.component.scss'],
})
export class ResultsQueryJsonComponent implements OnDestroy {
  @ViewChild('code') code: ElementRef;

  private $unsubscribe: Subject<void> = new Subject();
  private queries: _AbcTreeNode<Property>;
  private highlightSyntax: HighlightSyntax = new HighlightSyntax(this.renderer);

  constructor(
    private resultService: ResultsService,
    private abcQueriesEditorService: AbcQueriesEditorService,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.refreshQueriesData();
    this.resultService.queryDocument
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((resultQueryDocument: QueryObjectsModel) => {
        resultQueryDocument.OutputMode = QueryOutputMode.Json;
        resultQueryDocument.Indent = true;

        this.code.nativeElement.innerHTML = this.highlightSyntax.highlight(
          'json',
          JSON.stringify(resultQueryDocument, null, 2)
        ).value;
      });
  }

  public async refreshQueriesData(): Promise<void> {
    this.queries = this.abcQueriesEditorService.queries;
    if (this.queries) {
      await this.resultService.createObjectQueries(this.queries, this.abcQueriesEditorService.queryDocument);
    }
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
